// extracted by mini-css-extract-plugin
export default {"title":"patient-descriptor_title__rd4oF","values":"patient-descriptor_values__2IStz","value":"patient-descriptor_value__A5v4F","inactive":"patient-descriptor_inactive__eR7Lc"};